<template>
  <div>
    <table class="min-w-full">
      <thead>
        <tr>
          <th
            v-for="(item, key) in (sous_warehouses.length==0 && name == 'users'?headers.filter(i => i!='sous_warehouses'):headers)"
            :key="key"
            class="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-600 uppercase tracking-wider"
          >
          <span v-if="name=='statusHistories' && item=='dateDebut'">Date Action</span>
           <span v-else>{{ item }}</span>
            
          </th>
          <th
            class="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-600 uppercase tracking-wider"
          ></th>
        </tr>
      </thead>

      <tbody class="bg-white">
        <tr v-for="(item, index) in content" :key="index">
          <td v-for="(it, ind) in (sous_warehouses.length==0 && name == 'users'?headers.filter(item => item!='sous_warehouses'):headers)" :key="ind" class="px-2 py-3 whitespace-no-wrap border-b border-gray-200">
            <div v-if="it == 'type' && name == 'users'" class="text-xs leading-5 capitalize px-2 font-semibold rounded-full text-gray-900">
              <p v-if="(currentUser && currentUser.type && ['Admin','CallenterManager'].indexOf(currentUser.type) !== -1 && ['TeleConsultant','NRP'].indexOf(content[index][it]) !== -1)">
                <select
                  autocomplete="type"
                  v-model="content[index][it]"
                  @change="ChangeStatus(content[index],'type')"
                  class="font-semibold outline-none block h-full w-full bg-white"
                >
                  <option v-for="role in roles.filter(item => item.type === 'TeleConsultant' || item.type === 'NRP').map( el => el.type )" :key="'-'+role" :value="role">
                    {{ role }}
                  </option>
                </select>
              </p>
              <p v-else>{{ content[index][it] }}</p>
            </div>
            <div v-else-if="it == 'status' && name == 'users'">
              <p v-if="(currentUser && currentUser.type && ['Admin','Administrateur'].indexOf(currentUser.type) !== -1)">
                <select
                  id="type"
                  name="status"
                  autocomplete="type"
                  v-model="content[index][it]"
                  @change="ChangeStatus(content[index],'status')"
                  class="py-2 text-xs capitalize px-2 outline-none block h-full w-full bg-white"
                >
                  <option selected disabled :value="null">Status</option>
                  <option
                    v-for="(value, index) in status"
                    :key="index"
                    :value="value"
                  >
                    {{ value }}
                  </option>
                </select>
              </p>
              <p class="text-sm uppercase" v-else>{{ content[index][it] }}</p>
            </div>

            <div v-else-if="it == 'warehouses' && name == 'users'" class="flex">
                 <span v-for="(images, r) in content[index][it]" :key="r">
                        <img :src="images" class="w-4 h-4 rounded-full mr-2">
                  </span>
            </div>
            <div v-else-if="it == 'sous_warehouses' && name == 'users'" class="select2-container--default"> 
                  <ul class="select2-selection__rendered">
                     <li  v-for="(images, r) in content[index][it]" :key="r" class="select2-selection__choice">{{images}}</li>
                  </ul>
            </div>

            <div v-else-if="it == 'isConverted' && name == 'subscribers'">
              <div v-if="content[index][it]">
                <button
                  class="rounded-full flex items-center text-blue-500 focus:outline-none"
                >
                  <i class="material-icons mr-2">check_circle</i
                  ><span>Converted</span>
                </button>
              </div>

              

              <div v-else class="flex">
                <button
                  @click="convertUser(content[index])"
                  class="border capitalize rounded-full text-blue-500 h-8 px-8 bg-white hover:text-white hover:bg-blue-500 hover:border-blue-500 focus:outline-none appearance-none"
                >
                  Convert
                </button>
              </div>
            </div>

            <div v-else-if="it == 'status' && name == 'orders'">
              <p>
                <select
                  id="type"
                  name="status"
                  autocomplete="type"
                  v-model="content[index][it]"
                  @change="ChangeStatusOrder(content[index])"
                  class="py-2 text-xs capitalize px-2 outline-none block h-full w-full bg-white"
                >
                  <option selected disabled :value="null">Status</option>
                  <option
                    v-for="(value, index) in statusOrder"
                    :key="index"
                    :value="value"
                  >
                    {{ value.name }}
                  </option>
                </select>
              </p>
            </div>

            <div v-else class="text-sm capitalize leading-5 text-gray-900">
              {{  it === 'createdAt'?$moment(content[index][it]).format('yyyy-MM-DD'):content[index][it] }}
            </div>
          </td>
          <td
            v-if="name != 'productsOrder'"
            class="px-2 py-3 whitespace-no-wrap border-b border-gray-200"
          >
            <div class="flex justify-end">
              <router-link
                v-if="
                  getAccess(name, 'update') &&
                  name != 'statusHistories' &&
                  name != 'subscribers' &&
                  name != 'stockHistories' &&
                  currentUser.type != 'CallenterManager'
                "
                :class="$colors.actionTable"
                class="rounded-full flex justify-center items-center w-8 h-8 mr-3 mt-1"
                :to="`${name}/edit/${content[index]['_id']}`"
              >
                <i class="material-icons mx-2">edit</i>
              </router-link>
              <router-link
                v-if="
                  getAccess(name, 'update') &&
                  name == 'subscribers' &&
                  content[index]['isConverted'] != true
                "
                :class="$colors.actionTable"
                class="rounded-full flex justify-center items-center w-8 h-8 mr-3 mt-1"
                :to="`${name}/edit/${content[index]['_id']}`"
              >
                <i class="material-icons mx-2">edit</i>
              </router-link>

              <button
                v-if="getAccess(name, 'delete')"
                :class="$colors.actionTable"
                @click="remove(content[index]['_id'])"
                class="rounded-full flex justify-center items-center focus:outline-none w-8 h-8 mr-3 mt-1"
              >
                <i class="material-icons mx-2">delete</i>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>

    <div v-if="content.length <= 0" class="bg-blue-100 py-8">
      <span
        class="w-full flex justify-center text-center py-3 border-b border-gray-200 text-base"
      >
        <p class="font-semibold flex text-blue-500 whitespace-no-wrap">
          <i class="material-icons mx-3">error</i>
          <span class="">no rows selected </span>
        </p>
      </span>
    </div>
     <!--Modal set service seller Shipping -->
             <vue-modal-2  name="ModalChangeSetSettings" :headerOptions="{title: 'Convert user'}" :noFooter="true" modalSize="lg" @on-close="closeModal()">
                <div class="bg-white rounded-lg">

                    <div class="relative">
                        <div class="rounded-lg flex">
                            <div class="w-full p-4 pt-0">
                                <div class="text-base mb-5   font-medium truncate"> Seller: {{subscriber.fullName||''}} </div>
                                <div class="change-status border hover:border-blue-400 focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                                    <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                                        <p>
                                            <label for="settings" class="bg-white text-gray-700 px-1">Country (warhousing)</label>
                                        </p>
                                    </div> 
                                   <p>
                                    <v-select @input="setSelectedW" v-model="subscriber.warehouse"  :options="warehouses" label="name">
                                    <template slot="option" slot-scope="option">
                                        <img class="flag-img" :src="$f.getCountryCode(option.country)"/>
                                        {{ $f.getCountryNameByCode(options,option.country)}} 
                                    </template>
                                 </v-select>
                                  </p>
                                </div> 
                           </div>
                           </div>    
                          <div class="p-4 flex space-x-4">
                              <a href="#" @click="closeModal()" class="w-1/2 px-4 py-3 text-center bg-gray-500 text-white hover:bg-gray-400  font-bold rounded-lg text-sm">Cancel</a>
                              <a href="#" @click="confirmChange" class="w-1/2 px-4 py-3 text-center text-blue-100 bg-blue-600 rounded-lg hover:bg-blue-700 hover:text-white font-bold text-sm">Confirme</a>
                          </div>
                         </div> 
                    
                </div>
            </vue-modal-2>  
  </div>
</template>

<!--  ************  -->
<script>
export default {
  props: {
    headers: { default: [] },
    content: { default: [] },
    name: { type: String, default: "" },
    refresh: { type: Function },
    currentUser: { type: Object},
    idWharhouse: { type: Object},
    sous_idWharhouse: { type: String,default() {return null}},
    sous_warehouses: { type: Array,default() {return []}},
  },
  data() {
    return {
      filters: [],
      status: ["active", "inactive", "blocked", "deleted"],
      statusOrder: [],
      actions: [],
      warehouses:[],
      subscriber:{warehouse:null,fullName:""},
      subscriberConvert:{},
      options:this.$countries,
      paginate: {
        limit: 0,
        page: 1,
        total: 0,
        current_page: 0,
        lastpage: 0,
      },
      newSeller: {},
      roles: [],
      categories: [],
    };
  },
  async mounted() {
    //await this.getUser();
    if (this.currentUser.type == "Admin" || this.currentUser.type == "Administrateur" || this.currentUser.type=='CallenterManager') await this.getRoles();
    //await this.getStatus();
   // await this.getCategories();
  // await this.refreshChild();
  },
  methods: {
    async getWarehouses(){
        this.warehouses = this.currentUser.warehouses;
        // const filter = {limit:1000};
        // const res = await this.$server.search("warehouses",filter);
        // if (res.content.results) {
        //      this.warehouses = res.content.results;
        // } else this.warehouses = [];
    }, 
    closeModal(){
        this.$vm2.close('ModalChangeSetSettings');
    },
    setSelectedW(warhouse){
         if (warhouse) this.subscriber.warehouse = warhouse;
         else this.subscriber.warehouse = null;
    },
    async getUser() {
      const res = await this.$me;
      this.currentUser = res.content;
    },
    async getRoles() {
      const res = await this.$server.search("roles");
      if (res.content) this.roles = res.content.results;
      else this.roles = [];
    },
    async getCategories() {
      const res = await this.$server.search("categories");
      if (res.content) this.categories = res.content.results;
      else this.categories = [];
    },
    async remove(id) {
      this.$confirm("Are you sure ?").then(async (res) => {
        if (res) {
          const data = await this.$server.delete(this.name, { _id: id });
          //console.log("HIII");
          if (data && data._id) {
            alert(`${this.name} deleted !`, "success");
            await this.refreshChild();
          }else  alert(data, "warning");
        }
      });
    },
    async getStatus() {
      const res = await this.$server.search("status");
      if (res.content.results) this.statusOrder = res.content.results;
      else this.statusOrder = [];
    },
    async refreshChild() {
      await this.refresh();
    },
    async ChangeStatus(dataToEdit,type) {
     if(type=='status') dataToEdit.updateIntable=true;
     else dataToEdit.updateType=true;
     delete dataToEdit.sous_warehouses;
      const data = await this.$server.update("users", dataToEdit);
      if (data && data._id) {
        alert("User updated", "success");
      }else  alert(data, "warning");
    },

    async ChangeStatusOrder(dataToEdit) {
      const data = await this.$server.update("orders", dataToEdit);
      if (data._id) {
        alert("Order updated", "success");
      }
    },
    async getUser() {
      const res = await this.$server.me("users");
      if (res.content) this.currentUser = res.content;
      else this.currentUser = [];
    },
    async convertUser(subscriber) {
      console.log('subscriber-----',subscriber)
      await this.getWarehouses();
      this.subscriberConvert=subscriber;
      if(this.subscriberConvert.warehouse) {this.subscriber.warehouse=this.subscriberConvert.warehouse;this.subscriber.fullName=this.subscriberConvert.fullName;}
      this.$vm2.open('ModalChangeSetSettings');
    },
      async confirmChange(){
      if(!this.subscriber.warehouse){
         alert("Country (warhouse) est obligatoir !", "warning");
        return false;
      }
      if(!this.subscriberConvert._id){
        alert("Une erreur produit svp actualiser la page", "warning");
        return false;
      }
      this.$confirm("Are you sure you want to convert this subscriber ?").then(
        async (res) => {
          if (res) {
            this.subscriberConvert.warehouse=this.subscriber.warehouse._id||this.subscriber.warehouse;
            const data = await this.$server.convert("subscribers", this.subscriberConvert);
            this.closeModal();
            if (data && data._id) {
              await this.refresh();
              console.log('this.subscriber-----',this.subscriber)
              this.subscriber={warehouse:null,fullName:""};
              alert("subscriber converted !", "success");
            } else  alert(data, "warning");
          }
        }
      );
    },
    getAccess(modelToCheck, accessToCheck) {
      const permissions = this.currentUser.role.permissions;

      for (let i in permissions) {
        let model = permissions[i]["model"];
        let access = permissions[i]["access"];

        if (model == modelToCheck) {
          return access[accessToCheck];
        }
      }
    },
  },
};
</script>

<!--  ************  -->
<style>
dialog:not([open]) {
  display: none;
}
</style>